import React from 'react';
import { Typography } from '@mui/material';
import { TALK_STATUS_BADGE_THEME } from '../../types/talk';

interface TalkStatusBadgeProps {
  isActive: boolean;
  isResigned?: boolean;
  activeBadgeText?: string;
  inactiveBadgeText?: string;
}

/**
 * 対話状態を表示するための共通コンポーネント
 * 患者一覧と看護師一覧の両方で使用できます
 */
const TalkStatusBadge: React.FC<TalkStatusBadgeProps> = ({ 
  isActive, 
  isResigned = false,
  activeBadgeText = '対話中',
  inactiveBadgeText = '待機中'
}) => {
  return isActive ? (
    // 対話中 - シンプルなバッジスタイル
    <Typography
      variant="body2"
      sx={{
        display: 'inline-block',
        fontWeight: 'bold',
        color: TALK_STATUS_BADGE_THEME.ACTIVE.COLOR,
        border: `1px solid ${TALK_STATUS_BADGE_THEME.ACTIVE.BORDER}`,
        borderLeft: `4px solid ${TALK_STATUS_BADGE_THEME.ACTIVE.BORDER_LEFT}`,
        px: 1,
        py: 0.25,
        borderRadius: 0.5,
        opacity: isResigned ? 0.6 : 1,
        whiteSpace: 'nowrap',
      }}
    >
      {activeBadgeText}
    </Typography>
  ) : (
    // 待機中 - より控えめなテキスト表示
    <Typography
      variant="body2"
      sx={{
        display: 'inline-block',
        color: TALK_STATUS_BADGE_THEME.INACTIVE.COLOR,
        borderBottom: `1px dotted ${TALK_STATUS_BADGE_THEME.INACTIVE.BORDER_BOTTOM}`,
        px: 1,
        py: 0.25,
        opacity: isResigned ? 0.5 : 0.8,
        whiteSpace: 'nowrap',
      }}
    >
      {inactiveBadgeText}
    </Typography>
  );
};

export default TalkStatusBadge;